'use strict';

var colorManipulator = require('../node_modules/@material-ui/core/styles/colorManipulator.js');

var lighten = colorManipulator.lighten;

module.exports = lighten;
